import { Button, Layout as AntLayout } from 'antd';
import { HambergerMenu } from 'iconsax-react';

export function NavbarLoading() {
  const { Header } = AntLayout;
  return (
    <div className='flex flex-col flex-1'>
      <div className='flex flex-col mb-4 space-y-6 mt-2 animate-pulse'>
        <div className='w-full h-9 bg-gray/20 rounded-lg' />
      </div>
    </div>
  );
}
